import sendRequest from './sendRequest.js';

/**
 * ВСЕ data-* аттрибуты указываются полностью (напр. data-field)
 *
 * @param {string} selector Селектор кнопок
 * @param {string} targetData data-* аттрибут для получения ID элемента, из которого взять значение при отправке
 * @param {string} methodData data-* аттрибут для выбора метода
 * @param {string} urlData data-* аттрибут для установки адреса отправки (Если не установлен будет передан на текущую страницу)
 * @param {function} onsuccess Функция Callback выполняющая действия при удачном обмене данных
 */
function jsAjaxButtonHandler(
    selector,
    targetData = null,
    methodData = null,
    urlData = null,
    onsuccess = null
) {
    document.querySelectorAll(selector).forEach(
        item =>
        item.addEventListener('click', event => {
            event.preventDefault();
            var $this = event.target;
            $this.disabled = true;

            let method = "GET";
            let url = document.location.href;
            let param = {};

            if (urlData) {
                url = $this.getAttribute(urlData);
            }

            if (targetData) {
                let targetField = $this.getAttribute(targetData);
                param[targetField] = document.getElementById(targetField).value;
            }

            if (methodData) {
                method = $this.getAttribute(methodData);
            }

            sendRequest({
                url: url,
                method: method,
                data: param,
                success: function (res) {
                    $this.disabled = false;
                    if (onsuccess !== null) {
                        onsuccess(res, item);
                    }
                }
            });
        })
    )
}

export {
    sendRequest,
    jsAjaxButtonHandler
}